import styled from 'styled-components';

export const ErrorText = styled.span`
  color: #d69b9b;
  font-size: 11px;
  font-weight: 700;
`;
